// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__UAdyz","error":"Textarea_error__2asJh","readonly":"Textarea_readonly__1VSbE","disabled":"Textarea_disabled__2WOaR"};